import { Events, pubsub, Storage } from '@service';
import { ZipCodeQueryResponse } from '@model/http';

export class ZipcodeStore {
  static endpoint =
    'https://building-controls-solutions-default-rtdb.firebaseio.com/zip-codes.json';

  /** @type {Storage} */
  session = sessionStorage;

  async init() {
    this.session = Storage.sessionForKey('locationInformation');

    // Receiving a ZIP code from somewhere
    pubsub.sub(Events.zipCodeCollected, async zipCode => {
      const zipCodeData = await this.getZipCode(zipCode);

      // Announce that a zip code object was collected
      pubsub.pub(Events.zipCodeResolved, zipCodeData);

      // Store the data for quick access later
      sessionStorage.setItem('locationInformation', JSON.stringify(zipCodeData));

      // If there is a branch zip code in this object then we need to query the branch location store for it
      if (zipCodeData.branchZipCode) {
        pubsub.pub(Events.branchZipCodeCollected, zipCodeData.branchZipCode);
      }
    });
  }

  constructor() {
    this.init().then(() => {});
  }

  buildFirebaseQuery = zipCode => {
    const baseUrl =
      'https://building-controls-solutions-default-rtdb.firebaseio.com/zip-codes.json';
    const url = new URL(baseUrl);
    // The query string parameters have to be "JSON-encoded", which seems just to mean that
    // the parameter names have to be wrapped by double quotes.
    url.searchParams.set('orderBy', '"zip"');
    url.searchParams.set('equalTo', `"${zipCode}"`);
    return url.toString();
  };

  /**
   *
   * @param zipCode
   * @returns {Promise<ZipCodeQueryResponse>}
   */
  async getZipCode(zipCode) {
    return new Promise((resolve, reject) => {
      const url = this.buildFirebaseQuery(zipCode);

      fetch(url)
        .then(response => {
          if (!response.ok) {
            reject(response.status);
            return;
          }
          return response.json();
        })
        .then(data => {
          // We have a ZIP code object now that looks like:
          // {
          //     "some_property_do_not_care": {
          //         "this": "part",
          //         "is": "what we want",
          //         "zip": "12345",
          //         "city": "Some City"
          //     }

          // Get the first property of the object
          const zipCodeObject = Object.values(data)[0];
          const zipCodeResponse = ZipCodeQueryResponse.fromJSON(zipCodeObject);
          resolve(zipCodeResponse);
          return zipCodeResponse;
        });
    });
  }
}

const zipcodes = new ZipcodeStore();
export default zipcodes;
